export const environment = {
  production: true,
  admNome: 'MULTIMAX BENEFICIOS',
  apiUrl: 'https://api.g2saude.com.br/api/cliente',
  assets: 'multimaxbeneficios',
  base: 'leal',
  tipoPlanoId: 1, //1-plano de saude, 2-plano de odontologia, 3-plano pet
};
